import React from 'react';
import './i18n';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout';
import Home from './pages/Home';
import NotFound from './pages/not-found';
import ItHome from './pages/it/ItHome';
import VandroAutomation from './pages/VandroAutomation';

const queryClient = new QueryClient();



const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/it/*" element={<Layout><ItHome /></Layout>} />
            <Route path="/vandro-automation" element={<Layout><VandroAutomation /></Layout>} />
            <Route path="/vandro-rental" element={<Navigate to="/vandro-automation" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
      </Router>
      <Toaster position="top-right" />
    </QueryClientProvider>
  );
}

export default App;
